import { useEffect, useState } from 'react';
import Layout from '../../../Components/Layout/Layout';
import Toaster from '../../../Components/Toaster/Toaster';
import { useNavigate } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { AUTH_VISITOR_USER_SUCCESS } from '../../../Helpers/Constant';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';
import Loader from '../../../Components/Spinner/Loader';
import InputField from '../../../Components/Common/InputField';
import CommonImageUpload from '../../../Components/Common/CommonImageUpload';
import PostDataApis from '../../../Components/Common/FetchData/PostDataApis';
import ShowingPasswordValidationText from '../../../Components/Common/ShowingPasswordValidationText';
import OnlyRegistrationOTP from '../../../Components/Common/CheckPreviousRegistration/OnlyRegistrationOTP';
import { useCheckPreviousRegistration } from '../../../Components/Common/apiEndpoints/commApiEndpoints';

type VisitorInputForm = {
  visitor_first_name: string;
  visitor_last_name: string;
  visitor_email: string;
  visitor_phone: string;
  visitor_organization: string;
  visitor_password: string;
  visitor_confirm_password?: string;
  visitor_photo?: FileList;
  [key: string]: any;
};

const VisitorRegistration = () => {
  const [back, setBack] = useState(false);
  const [registrationData, setRegistrationData] = useState<VisitorInputForm>();
  const {
    mutate,
    isSuccess: otpSuccess,
    isPending,
  } = useCheckPreviousRegistration();
  const { dispatch: authDispatch, setIsLoading } = VisitorAuthContext();
  const Toast = Toaster();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    setValue,
    formState: { errors },
    resetField,
    watch,
  } = useForm<VisitorInputForm>();
  const [passwordType, setPasswordType] = useState<string>('password');
  const { postData, loading, response, token } = PostDataApis(
    '/api/auth/visitor/registration'
  );

  useEffect(() => {
    if (response && token) {
      Toast.fire({
        icon: 'success',
        title: `successfully register`,
      });
      authDispatch?.({
        type: AUTH_VISITOR_USER_SUCCESS,
        payload: { ...response, token },
      });
      localStorage.setItem('toab_visitor_token', token);
      setIsLoading?.(false);
      navigate('/visitor/profile');
    }
  }, [response, token]);

  const onSubmit: SubmitHandler<VisitorInputForm> = async (
    value: VisitorInputForm
  ) => {
    const { visitor_confirm_password, ...data } = value || {};
    if (data?.visitor_password !== visitor_confirm_password) {
      Toast.fire({
        icon: 'error',
        title: `Password does not match `,
      });

      return;
    }
    if (data?.visitor_password?.length < 8) {
      Toast.fire({
        icon: 'error',
        title: `Password must be at least 8 characters`,
      });

      return;
    }
    if (data?.visitor_password?.length > 16) {
      Toast.fire({
        icon: 'error',
        title: `Maximum password length is 16 characters`,
      });

      return;
    }

    mutate({
      email: data?.visitor_email,
      type: 'register_visitor',
      phone: data.visitor_phone,
    });
    setRegistrationData(data);
    setBack(false);
  };

  const handleRegistration = async (value: boolean) => {
    setIsLoading?.(true);
    if (value && registrationData) {
      const fromData = new FormData();
      Object.keys(registrationData).forEach((item) => {
        if (item === 'visitor_photo' && registrationData?.visitor_photo) {
          fromData.append(item, registrationData.visitor_photo[0]);
        } else {
          fromData.append(item, registrationData[item]);
        }
      });
      await postData(fromData);
    }
  };

  return (
    <Layout>
      {registrationData?.visitor_email && otpSuccess && !back ? (
        <OnlyRegistrationOTP
          email={(registrationData as VisitorInputForm)?.visitor_email}
          handleRegistration={handleRegistration}
          type='register_visitor'
          setBack={setBack}
        />
      ) : (
        <div className='login-wrapper'>
          <div className='login-div mt-4'>
            <div className='visitor-registration-page'>
              <div className='text-center'>
                <p className='fw-bold fs-3'>Visitor Registration</p>
              </div>

              <div className='login-form'>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className='row g-3 mx'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-4'>
                      <div>
                        <InputField
                          type='text'
                          isRequired
                          label='First Name'
                          register={register('visitor_first_name')}
                          placeholder='Enter first name'
                        />
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-4'>
                      <div>
                        <InputField
                          type='text'
                          isRequired
                          label='Last Name'
                          register={register('visitor_last_name')}
                          placeholder='Enter last name'
                        />
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-4'>
                      <div>
                        <InputField
                          label='Email'
                          register={register('visitor_email')}
                          type='email'
                          isRequired
                          placeholder='Enter email address'
                        />
                      </div>
                    </div>{' '}
                    <div className='col-12 col-sm-12 col-md-6 col-lg-4'>
                      <div>
                        <InputField
                          label='Mobile Number'
                          register={register('visitor_phone')}
                          type='text'
                          isRequired
                          placeholder='Enter mobile number'
                        />
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-4'>
                      <div>
                        <InputField
                          type='text'
                          label='Organization'
                          register={register('visitor_organization')}
                          placeholder='Enter Organization'
                        />
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className='row'>
                        <div className='col-sm-12 col-md-6 col-lg-4'>
                          <CommonImageUpload
                            register={register}
                            setError={setError}
                            clearErrors={clearErrors}
                            setValue={setValue}
                            resetField={resetField}
                            errors={errors}
                            label='Profile Photo'
                            fileName='visitor_photo'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-4'>
                      <div>
                        <InputField
                          label='Password'
                          register={register('visitor_password')}
                          type={passwordType}
                          isRequired
                          placeholder='Enter password'
                        />
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-4'>
                      <div>
                        <InputField
                          label='Confirm Password'
                          register={register('visitor_confirm_password')}
                          type={passwordType}
                          isRequired
                          placeholder='Enter confirm password'
                        />
                      </div>
                    </div>
                  </div>
                  {((watch('visitor_password') &&
                    watch('visitor_password')?.length < 8) ||
                    watch('visitor_password')?.length > 16) && (
                    <ShowingPasswordValidationText />
                  )}
                  <div className='mt-2'>
                    <div className=' d-flex align-items-center'>
                      <input
                        type='checkbox'
                        onClick={() => {
                          passwordType === 'password'
                            ? setPasswordType('text')
                            : setPasswordType('password');
                        }}
                      />
                      <p className='ps-2'>Show password</p>
                    </div>
                  </div>

                  <div>
                    {isPending ? (
                      <Loader css={'w-100 mt-3 text-white'} />
                    ) : (
                      <Button
                        type='submit'
                        className='w-100 mt-3 submit-button common-btn'
                      >
                        Register
                      </Button>
                    )}
                  </div>

                  <div className='mt-3 text-end'>
                    <Link
                      to='/visitor-login'
                      className='text-decoration-none fw-bold'
                    >
                      Back to login
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default VisitorRegistration;
